// src/Navbar.js
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CgProfile } from 'react-icons/cg';
import './Navbar.css';
const STRIPE_PORTAL_URL = process.env.REACT_APP_STRIPE_PORTAL_URL;

function Navbar() {
  // Initialize directly from localStorage so we show the current URL immediately
  const [profilePicSrc, setProfilePicSrc] = useState(
    localStorage.getItem('googlePhotoURL') || ''
  );
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  // Determine login status
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  const location = useLocation(); // <-- get current path

  useEffect(() => {
    // on every route change, re-read the stored photo URL
    setProfilePicSrc(localStorage.getItem('googlePhotoURL') || '');

    // listen for custom event when photo changes
    const handlePhotoChange = () => {
      setProfilePicSrc(localStorage.getItem('googlePhotoURL') || '');
    };
    window.addEventListener('googlePhotoURLChanged', handlePhotoChange);

    // your existing scroll listener
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('googlePhotoURLChanged', handlePhotoChange);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [location.pathname]);

  const handleImageError = () => {
    setProfilePicSrc('');
  };

  // helper to test active state
  const isActive = (path) => location.pathname === path;

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <Link to="/" className="nav-logo">
        <img
          src="/jobquelogo2.png"
          alt="Jobque.ai Logo"
          className="logo-image"
          onError={handleImageError}
        />
      </Link>

      {/* Hamburger icon (visible on mobile) */}
      <div
        className={`hamburger ${isOpen ? 'active' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="bar" />
        <span className="bar" />
        <span className="bar" />
      </div>

      {/* Nav links */}
      <ul className={`nav-links ${isOpen ? 'open' : ''}`}>
        <li>
          <Link
            to="/"
            onClick={() => setIsOpen(false)}
            className={isActive('/') ? 'active' : ''}
          >
            Home
          </Link>
        </li>

        {/* NEW EXTENSION TAB */}
        <li>
          <Link
            to="/extension"
            onClick={() => setIsOpen(false)}
            className={isActive('/extension') ? 'active' : ''}
          >
            Extension
          </Link>
        </li>

        <li>
          <Link
            to="/faq"
            onClick={() => setIsOpen(false)}
            className={isActive('/faq') ? 'active' : ''}
          >
            FAQ
          </Link>
        </li>

        <li>
          <Link
            to="/pricing"
            onClick={() => setIsOpen(false)}
            className={isActive('/pricing') ? 'active' : ''}
          >
            Pricing
          </Link>
        </li>
        <li>
          <Link
            to="/contact"
            onClick={() => setIsOpen(false)}
            className={isActive('/contact') ? 'active' : ''}
          >
            Contact
          </Link>
        </li>
        <li>
          <Link
            to="/outplacement"
            onClick={() => setIsOpen(false)}
            className={isActive('/outplacement') ? 'active' : ''}
          >
            Outplacement
          </Link>
        </li>
        <li>
          <Link
            to="/tool"
            onClick={() => setIsOpen(false)}
            className={isActive('/tool') ? 'active' : ''}
          >
            Job Center
          </Link>
        </li>
        <li>
          {isLoggedIn ? (
            <Link
              to="/profile"
              className={`profile-icon ${isActive('/profile') ? 'active' : ''}`}
              onClick={() => setIsOpen(false)}
            >
              {profilePicSrc ? (
                <img
                  src={profilePicSrc}
                  alt="Profile"
                  className="profile-image"
                  onError={handleImageError}
                />
              ) : (
                <CgProfile color="white" size={32} />
              )}
            </Link>
          ) : (
            <Link
              to="/signup"
              className={`signup-link ${isActive('/signup') ? 'active' : ''}`}
              onClick={() => setIsOpen(false)}
            >
              Sign Up
            </Link>
          )}
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;